// extracted by css-extract-rspack-plugin
export default {"Page":"styles-module__Page__OamNo"};